/**
 * Mailing list API service (#205).
 * Submits a pre-launch email signup to the server, which writes it to the
 * MailingList collection. Public, unauthenticated — same plain-fetch
 * pattern as feedbackApi.js, not the authenticated useXApi() hook pattern,
 * since this form has no signed-in user.
 */

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

/**
 * Join the mailing list.
 *
 * @param {Object} params
 * @param {string} params.email        - The address to subscribe.
 * @param {string} [params.referralCode] - Honeypot field; real users leave it
 *   empty. Forwarded as-is so the server can reject a filled value.
 * @returns {Promise<{ message: string }>}
 */
export async function subscribeToMailingList({ email, referralCode }) {
    const response = await fetch(`${API_BASE_URL}/mailing-list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, referralCode }),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(
            data.message || `HTTP error! status: ${response.status}`
        );
    }

    return data;
}

export default { subscribeToMailingList };
